import { context } from './context';

import { useGetContextOrError } from '../hooks/use-get-context-or-error';

export const usePreviousPath = () =>
  useGetContextOrError(context, 'Previous Path');
